import axios from "axios";
import utils from "@/utils";

function errorHandler(error) {
  return new Promise((resolve, reject) => {
    reject(error);
  });
}

class NitroClient {
  constructor(crmURL, crmVersion, sfEndpoint, orgId) {
    this._crmURL = crmURL;
    this._crmVersion = crmVersion;
    this._sfEndpoint = sfEndpoint;
    this._orgId = orgId;
  }

  fetchNitroTable(eventInfo) {
    const url = `${this._crmURL}/${this._crmVersion}/api/v1/vds/data`;
    const object = eventInfo.object;
    const fields = eventInfo.fields;
    const limit = eventInfo.limit;
    const sort = Array.isArray(eventInfo.sort) ? eventInfo.sort : [];
    const where = eventInfo.where || "";
    const config = {
      headers: {
        sfEndpoint: this._sfEndpoint
      }
    };

    const data = {
      object,
      fields,
      limit,
      sort,
      where
    };

    return axios.post(url, data, config).then(resp => {
      if (resp.data && resp.data.status === "SUCCESS") {
        return utils.formatNitroResponseForPreview(resp.data.data);
      } else {
        throw {
          name: "APIRequestError",
          message: "API request was not successful"
        };
      }
    }, errorHandler);
  }
}

export default NitroClient;
